"use client";
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useState, useRef, useId, Children } from 'react';
import { validateSurface } from '../../globals.js';
import { Line } from '../../lines/line/index.js';
import '../../_virtual/_tslib.js';
import useViewport from '../../utilities/use-viewport/index.js';
import { AccordionItem } from './accordion-item.js';

/**
 * @component Accordion
 * @package Accordion
 * @document ../_docs/code/Accordion.editor.tsx
 * @document ../_docs/code/Accordion.snippet.tsx
 * @document ../_docs/code/Accordion.import.tsx
 */
const Accordion = ({ id, viewport: viewportProp, topLine = false, bottomLine = true, surface: surfaceProp = 'lightPrimary', padding = 'standard', behavior = 'multiOpen', triggerElement = 'icon', triggerAlignment = 'top', items, width = '100%', children, }) => {
    const [activeAccordionID, setactiveAccordionID] = useState(undefined);
    const idPrefix = useRef(null);
    const _useId = useId();
    const viewport = useViewport('standard', viewportProp);
    const surface = validateSurface(surfaceProp);
    if (idPrefix.current === null)
        idPrefix.current = id || _useId;
    const _renderLine = (isVisible) => (jsx(Line, { surface: surface, color: isVisible ? 'subtle' : 'transparent' }));
    const validChildren = Children.toArray(children).filter(Boolean);
    return (jsx("div", { style: { width }, className: "accordion", id: id, children: items && items.length > 0 ? (jsx(Fragment, { children: items.map((item, index) => (jsxs(Fragment, { children: [_renderLine(topLine || index !== 0), jsx(AccordionItem, Object.assign({ activeAccordionID: activeAccordionID, accordionItemId: `${idPrefix.current}_${index}`, surface: surface, padding: padding, behavior: behavior, viewport: viewport, triggerElement: triggerElement, triggerAlignment: triggerAlignment, onClick: (updatedID) => {
                            setactiveAccordionID(updatedID);
                        } }, item), index + 1), _renderLine(bottomLine && index === items.length - 1)] }))) })) : (jsx(Fragment, { children: validChildren.map((child, index) => {
                const showBottomLine = index === validChildren.length - 1;
                return (jsxs(Fragment, { children: [_renderLine(topLine || index !== 0), child, _renderLine(bottomLine && showBottomLine)] }));
            }) })) }));
};

export { Accordion, Accordion as default };
